import fetch from '../../../services/fetch-api.service';

const fetchAreas = ({ filters, page, sortField, sortOrder, limit }) => fetch.get('admin/areas/list', { filters, page, sortField, sortOrder, limit });

export default {
  fetchAreas,
};
